"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const toolkit_1 = require("@reduxjs/toolkit");
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const store_1 = require("../../store");
const input_1 = __importStar(require("../../components/input/input"));
const utils_1 = require("../../utils/utils");
const text_1 = __importStar(require("../../components/text/text"));
const primaryButton_1 = __importDefault(require("../../components/primaryButton/primaryButton"));
const remitaUtils_1 = require("./remitaUtils");
const navContainer_1 = __importDefault(require("../../components/navContainer/navContainer"));
const homeSlice_1 = require("../home/homeSlice");
const icon_1 = require("../../components/icon/icon");
const screenConstants_1 = require("../../constants/screenConstants");
const styles_1 = __importDefault(require("../../styles/styles"));
const useGetUpdates_1 = __importDefault(require("../../hooks/useGetUpdates"));
const RemitaConnection = ({ errors, setErrors }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const navigation = (0, useAppNavigation_1.default)();
    const { t } = (0, react_i18next_1.useTranslation)();
    (0, useGetUpdates_1.default)();
    const { ongoingLoanApplicationId } = (0, store_1.useAppSelector)((state) => ({
        ongoingLoanApplicationId: state.home.ongoing_application,
    }));
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [remitaField, setRemitaField] = (0, react_1.useState)([]);
    const [message, setMessage] = (0, react_1.useState)('');
    const [remitaInputs, setRemitaInputs] = (0, react_1.useState)([]);
    // Remita Transaction Status
    const remitaAuthDataStatus = async () => {
        setIsLoading(true);
        const payload = {
            loan_application_id: ongoingLoanApplicationId ? ongoingLoanApplicationId.id : '',
        };
        const result = await dispatch((0, remitaUtils_1.remitaTransactionStatus)(payload));
        if ((0, toolkit_1.isFulfilled)(result)) {
            setIsLoading(false);
            setRemitaInputs(result.payload.auth_params);
        }
        else {
            setIsLoading(false);
        }
    };
    // REQUEST Remita
    const requestRemitaAuthData = async () => {
        setIsLoading(true);
        const payload = {
            loan_application_id: ongoingLoanApplicationId ? ongoingLoanApplicationId.id : '',
        };
        const result = await dispatch((0, remitaUtils_1.remitaRequest)(payload));
        if ((0, toolkit_1.isFulfilled)(result)) {
            setIsLoading(false);
            setMessage(result.payload.message ? result.payload.message : '');
            setRemitaInputs(result.payload.auth_params);
        }
        else {
            setIsLoading(false);
            setErrors(result.payload);
        }
    };
    const getRemitaFieldsDict = () => {
        // ADD THE VALUE WE GET FROM THE FIELDS WE GOT FROM PARAMS
        let remitaFieldsDict; // eslint-disable-line
        if (remitaInputs) {
            remitaFieldsDict = Array.isArray(remitaInputs)
                ? remitaInputs.map((x) => ({ ...x, value: remitaField[Number(x.key)] }))
                : []; // eslint-disable-line
        }
        else {
            remitaFieldsDict = [];
        }
        return remitaFieldsDict;
    };
    // validate Remita
    const validateRemitaAuthData = async () => {
        setIsLoading(true);
        const payload = {
            loan_application_id: ongoingLoanApplicationId ? ongoingLoanApplicationId.id : '',
            auth_params: getRemitaFieldsDict(),
        };
        const result = await dispatch((0, remitaUtils_1.remitaValidation)(payload));
        if ((0, toolkit_1.isFulfilled)(result)) {
            setIsLoading(false);
            setMessage(result.payload.message ? result.payload.message : '');
            dispatch((0, homeSlice_1.addMessages)([
                {
                    title: 'Connected successfully',
                    message: `${message}`,
                    iconType: icon_1.APPMESSAGE_CHECK_CIRCLE,
                    iconColor: '',
                    iconSize: 55,
                    buttonText: 'Continue',
                    hasLogo: false,
                    actionButton: () => {
                        navigation.navigate(screenConstants_1.HOME_SCREEN);
                    },
                },
            ]));
            dispatch((0, homeSlice_1.showMessage)());
        }
        else {
            setIsLoading(false);
            setErrors(result.payload);
        }
    };
    (0, react_1.useEffect)(() => {
        remitaAuthDataStatus();
    }, []);
    const updateRemitaFieldArray = (index, newValue) => {
        const newArray = [...remitaField];
        newArray[index] = newValue;
        return setRemitaField(newArray);
    };
    const checkButtonDisabled = () => {
        if (!remitaInputs ||
            !remitaField ||
            remitaField.includes('') ||
            remitaField.some((field) => field === '') ||
            (remitaField &&
                (remitaField[0] === undefined
                    ? remitaField.length < remitaInputs.length + 1
                    : remitaField.length < remitaInputs.length)))
            return true;
        return false;
    };
    return (react_1.default.createElement(navContainer_1.default, { errors: errors, isLoading: isLoading, childrenTitle: "Remita", footer: react_1.default.createElement(primaryButton_1.default, { title: "Confirm", onPress: validateRemitaAuthData, eventName: "validate_connect_remita", disabled: checkButtonDisabled() }), message: message },
        react_1.default.createElement(react_native_1.View, { style: [
                styles_1.default.centerChildHorizontalVertical,
                styles_1.default.minimumMarginBetweenElementsVertically,
            ] },
            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, t('remita.remita_auth_data'))),
        react_1.default.createElement(primaryButton_1.default, { title: "Request Authorization", onPress: requestRemitaAuthData, eventName: "request_to_connect_remita" }),
        remitaInputs && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.centerChildHorizontalVertical, { paddingTop: 20 }] },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, t('remita.remita_data_inputs'))),
            Array.isArray(remitaInputs) ? (remitaInputs.map((remitaInput) => (react_1.default.createElement(react_native_1.View, { key: remitaInput.key },
                react_1.default.createElement(input_1.default, { key: remitaInput.key, type: remitaInput.param === 'OTP' ? input_1.INPUT_TYPE_PASSWORD : input_1.INPUT_TYPE_NUMBER, label: remitaInput.label, placeholder: remitaInput.label, hasSetValueCustom: true, setValueCustom: (text) => {
                        checkButtonDisabled();
                        updateRemitaFieldArray(Number(remitaInput.key), text);
                    }, error: (0, utils_1.getError)(remitaInput.param, errors), value: remitaField[Number(remitaInput.key)] !== undefined
                        ? remitaField[Number(remitaInput.key)].toString()
                        : '' }),
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE_SIZE_12 }, remitaInput.description))))) : (react_1.default.createElement(react_native_1.View, null))))));
};
exports.default = RemitaConnection;
